var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.325 14.03l-5.76-3.389a.985.985 0 00-1.046.02 1.147 1.147 0 00-.519.979v6.72c0 .405.193.77.515.977a1 1 0 00.542.163.998.998 0 00.502-.137l5.76-3.331c.341-.198.554-.58.556-.998a1.153 1.153 0 00-.55-1.003z",
    fill: "#292929"
  })));
}
export default SvgUiPlay;